import { setLocale } from 'yup';

import validationLocale from 'constants/validationLocale';

setLocale(validationLocale);
